import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { BaseApiService } from '../../../../shared/services/base-api.service';

@Injectable({
  providedIn: 'root'
})
export class BaseWooCommerceV3RestaurantApiService extends BaseApiService {
  constructor(httpClient: HttpClient) {
    const baseApiUrl: string = environment.happyApi.baseUrl;
    super(httpClient, baseApiUrl);
  }
}
